import { render } from "./MonthlyLeadsChart.vue?vue&type=template&id=0abd9cbe"
import script from "./MonthlyLeadsChart.vue?vue&type=script&lang=js"
export * from "./MonthlyLeadsChart.vue?vue&type=script&lang=js"
script.render = render

export default script